import * as Event from '../tools/Event';
import { addClass, removeClass, hasClass } from '../tools/DOM';
import { MQ } from '../tools/MQ';


export const init = () => {
	const SCROLLABLE_SELECTOR = '.m-main__list--main';
	const ITEM_SELECTOR = '.m-main__item';
	const TOGGLE_SELECTOR = '.m-main__toggle';
	const TOGGLE_USER_MENU_SELECTOR = '.js-user-menu';
	const SUBMENU_SELECTOR = '.m-main__submenu';
	const MENU_SELECTOR = '.m-main';
	const FOCUSED_CLASS = 'is-focused';
	const OPENED_CLASS = 'is-opened';
	const HTML_OPENED_CLASS = 'menu-opened';
	const html = document.documentElement;
	const items = [...document.querySelectorAll(ITEM_SELECTOR)];
	let isDragging = false;

	const onMouseover = (event) => {
		const item = event.target.closest(ITEM_SELECTOR);
		const submenu = item.querySelector(SUBMENU_SELECTOR);

		if (!submenu) return;

		submenu.style.left = '';

		const menu = item.closest(MENU_SELECTOR);
		const submenuBox = submenu.getBoundingClientRect();
		const menuBox = menu.getBoundingClientRect();
		const diff = submenuBox.right - menuBox.right;
		const isBleeding = diff > 0;


		items.forEach((item) => {
			const link = item.querySelector('.m-main__link');

			removeClass(item, FOCUSED_CLASS);
			link.blur();
		});

		if (isBleeding) {
			submenu.style.left = `-${diff}px`;
		}
	};

	const onFocusIn = (event) => {
		if (MQ('desktopMax')) return;

		onMouseover(event);

		const item = event.target.closest(ITEM_SELECTOR);

		addClass(item, FOCUSED_CLASS);
	};

	const onFocusOut = (event) => {
		if (MQ('desktopMax')) return;

		const item = event.target.closest(ITEM_SELECTOR);

		removeClass(item, FOCUSED_CLASS);
	};

	const onToggle = (event) => {
		event.preventDefault();
		const menu = event.target.closest(MENU_SELECTOR);
		const isOpened = hasClass(menu, OPENED_CLASS);

		if (isOpened) {
			close(menu);
		} else {
			open(menu);
		}
	};

	const onToggleUserMenu = (event) => {
		event.preventDefault();
		const submenu = event.target.closest(ITEM_SELECTOR).querySelector(SUBMENU_SELECTOR);
		const isOpened = hasClass(submenu, OPENED_CLASS);

		if (isOpened) {
			closeUserMenu(submenu);
		} else {
			openUserMenu(submenu);
		}
	};

	const closeUserMenu = (submenu) => {
		removeClass(submenu, OPENED_CLASS);
	};

	const openUserMenu = (submenu) => {
		const menu = document.querySelector(MENU_SELECTOR);

		close(menu);
		addClass(submenu, OPENED_CLASS);
	};

	const close = (menu) => {
		const scrollable = menu.querySelector(SCROLLABLE_SELECTOR);

		if (scrollable) {
			scrollable.style.maxHeight = '';
		}

		removeClass(menu, OPENED_CLASS);
		removeClass(html, HTML_OPENED_CLASS);
	};

	const open = (menu) => {
		const menuHeight = document.querySelector('.header__menu').offsetHeight;
		const maxHeight = window.innerHeight - menuHeight;

		menu.querySelector(SCROLLABLE_SELECTOR).style.maxHeight = `${maxHeight}px`;

		addClass(menu, OPENED_CLASS);
		addClass(html, HTML_OPENED_CLASS);
	};

	const onTouchend = (event) => {
		const submenu = [...document.querySelectorAll(SUBMENU_SELECTOR)];
		const isSubmenu = event.target.closest(SUBMENU_SELECTOR);
		const isToggleUserMenu = event.target.closest(TOGGLE_USER_MENU_SELECTOR);

		if (!isSubmenu && !isToggleUserMenu) {
			submenu.forEach(closeUserMenu);
		}

		if (isDragging) return;

		const menu = [...document.querySelectorAll(MENU_SELECTOR)];
		const isMenu = event.target.closest(MENU_SELECTOR);

		if (!isMenu) {
			menu.forEach(close);
		}
	};

	const preventBodyScroll = (event) => {
		isDragging = true;

		const isMenuOpened = hasClass(html, HTML_OPENED_CLASS);


		if (isMenuOpened) {
			const scrollable = event.target.closest(SCROLLABLE_SELECTOR);

			if (scrollable) {
				const scrollableHeight = scrollable.scrollHeight;
				const offsetHeight = scrollable.offsetHeight;

				if (scrollableHeight > offsetHeight) return;
			}

			event.preventDefault();
		}
	};

	const preventMenuOverscroll = (event) => {
		const scrollable = event.target.closest(SCROLLABLE_SELECTOR);
		const scrolled = scrollable.scrollTop;
		const isTop = scrolled === 0;
		const isBottom = scrollable.scrollHeight === scrollable.scrollTop + scrollable.offsetHeight;


		if (isTop) {
			scrollable.scrollTop = 1;
		} else if (isBottom) {
			scrollable.scrollTop -= 1;
		}
	};


	items.forEach((item) => {
		Event.on(item, 'mouseenter', onMouseover);
		Event.on(item, 'focusin', onFocusIn);
		Event.on(item, 'focusout', onFocusOut);
	});
	Event.on(document, 'click', onToggle, TOGGLE_SELECTOR);
	Event.on(document, 'click', onToggleUserMenu, TOGGLE_USER_MENU_SELECTOR);
	Event.on(document, 'touchstart', () => { isDragging = false; });
	Event.on(document, 'touchend click', onTouchend);
	Event.on(document, 'touchmove', preventBodyScroll);
	Event.on(html, 'touchstart', preventMenuOverscroll, SCROLLABLE_SELECTOR);
};



// WEBPACK FOOTER //
// ./src/js/components/menuMain.js